<div class="">
  <div class="row">
    <div class="col-md-6 d-none d-md-block">
      <div class="image">
        <img
          src="assets/images/signup.png"
          class="img-fluid"
          style="height: 100vh !important"
          alt="Responsive Image"
          />
      </div>
    </div>

    <div
      class="col-md-6 d-flex justify-content-center align-items-center form-group uiIcon"
      style="height: 100vh !important"
      >
      <div class="inputs w-100">
        <!-- Input box or form elements -->

        <div class="text-center">
          <div class="sign-form">
            <h4 class="sign-form-head text-center">Create Your Account</h4>

            <p class="text-center signup-trailtext">
              Let’s get started with your 60 day’s free trial
            </p>

            <!-- <div class="alert alert-warning d-none" id="warning-box"></div>
            <div class="alert alert-danger d-none" id="error-box"></div>
            <div class="alert alert-success d-none" id="success-box"></div> -->
            <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
              <div class="form-group uiIcon">
                <input
                  style="
                    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
                    border-radius: 50px;
                  "
                  type="text"
                  formControlName="name"
                  class="input form-control"
                  placeholder="Full Name"
                  required
                  />
                <svg
                  class="svgIcon fill-smoke--d"
                  width="30"
                  height="30"
                  viewBox="0 -6 30 30"
                  enable-background="new 0 -6 30 30"
                  >
                  <path
                    d="M22.9 16.2c.1-.1.1-.3.1-.4-.2-.8-.5-1.4-.9-1.9s-1-1-1.7-1.4c-.2-.1-.6-.3-1.3-.6-.6-.2-1.1-.4-1.4-.6-.3-.2-.6-.4-.7-.7-.1-.4.1-1 .5-1.7 1.5-2.3 1.8-4.3.8-5.9-.3-.6-.7-1.1-1.3-1.5-.6-.3-1.3-.5-2-.5s-1.4.2-2 .5c-.6.4-1.1.8-1.5 1.5-1 1.6-.7 3.6.8 5.9.5.7.7 1.3.5 1.7-.1.2-.2.4-.5.6-.2.2-.5.3-.7.4-.2.1-.5.2-.9.4-.6.3-1.1.4-1.3.6-.7.4-1.3.9-1.7 1.4-.2.4-.5 1-.7 1.8 0 .1 0 .3.1.4l.3.3c1.6.3 4.1.5 7.6.5 2.3 0 4.2-.1 5.8-.3.2 0 .4 0 .6-.1.2 0 .4-.1.5-.1l.3-.1h.30000000000000004c.2 0 .3-.1.4-.2z"
                  ></path>
                </svg>
                @if (
                  signupForm?.controls?.name?.errors?.required &&
                  signupForm?.controls?.name?.touched
                  ) {
                  <span
                    style="color: red"
                    >Enter Valid User Name</span
                    >
                  }
                </div>
                <div class="form-group uiIcon">
                  <input
                  style="
                    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
                    border-radius: 50px;
                  "
                    type="email"
                    formControlName="email"
                    class="input form-control"
                    placeholder="Email Address"
                    required
                    />
                  <svg
                    class="svgIcon fill-smoke--d"
                    width="30"
                    height="30"
                    viewBox="0 -6 30 30"
                    enable-background="new 0 -6 30 30"
                    >
                    <path
                      d="M15 11.9c-.9 0-1.7-.2-2.3-.7l-5.7-4.4v8.1c0 .1 0 .3.1.4.1.1.2.2.3.2 2.5.4 5 .5 7.5.5s5-.2 7.5-.5c.1 0 .3-.1.4-.2.2-.1.2-.3.2-.4v-8.1l-5.7 4.4c-.6.5-1.4.7-2.3.7zm-1.3-2.3c.3.3.8.4 1.3.4s1-.1 1.3-.4l6.1-4.7c.3-.3.5-.6.6-1v-.8c0-.1 0-.3-.1-.4-.1-.1-.2-.2-.4-.2-2.5-.3-5-.5-7.5-.5s-5 .2-7.5.5c-.1 0-.2.1-.3.2-.2.1-.2.3-.2.4v.9c.1.3.3.6.6 1l6.1 4.6z"
                    ></path>
                  </svg>

                  @if (
                    signupForm?.controls?.email?.invalid &&
                    signupForm?.controls?.email?.touched
                    ) {
                    <span
                      style="color: red"
                      >Enter Valid E-mail</span
                      >
                    }
                  </div>
                  <div class="form-group uiIcon">
                    <input
                  style="
                    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
                    border-radius: 50px;
                  "
                      type="password"
                      formControlName="password"
                      class="input form-control"
                      placeholder="Password"
                      required
                      />
                    <svg
                      class="svgIcon fill-smoke--d"
                      width="30"
                      height="30"
                      viewBox="0 -6 30 30"
                      enable-background="new 0 -6 30 30"
                      >
                      <path
                        d="M21.6 8.3c-.2-.2-.5-.3-.9-.3h-.7v-2.6c0-1.3-.5-2.4-1.4-3.2-.9-.8-2.1-1.2-3.6-1.2s-2.7.4-3.6 1.2c-.9.8-1.4 1.9-1.4 3.2v2.6h-.7c-.3 0-.7.1-.9.4-.3.2-.4.5-.4.8v6.1c0 .3.1.5.3.7.2.2.4.3.7.4 1.9.4 3.9.6 6 .6 2 0 4-.2 5.9-.6.3-.1.5-.2.7-.4.2-.2.3-.4.3-.7v-6.1c.1-.3 0-.6-.3-.9zm-8.6-2.4c0-1.3.7-1.9 2-1.9s2 .6 2 1.9v2.1h-4v-2.1z"
                      ></path>
                    </svg>

                    @if (
                      signupForm?.controls?.password?.invalid &&
                      signupForm?.controls?.password?.touched
                      ) {
                      <span
                        style="color: red"
                        >Password Wrong</span
                        >
                      }
                      <br />
                    </div>

                    <div class="text-center text-primary loader my-2 d-none">
                      <div class="">
                        <i class="fa fa-spin fa-spinner fa-2x"></i><br />
                      </div>
                    </div>

                    <!-- <div class="form-group">
                    <p class="alert alert-danger" style="white-space: normal">
                      Signup disabled, kindly login with demo credentials on login pag
                      e.
                    </p>
                  </div> -->

                  <div class="form-group click={signupComponent}">
                    <button
                      type="submit"
                      class="btn btn-primary btn-block"
                  style="
                    border-radius: 50px;
                    background: #2758bf;
                    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
                  "
                      >
                      Signup for Free
                    </button>
                  </div>
                </form>
                <div class="clickable-div" onclick="makeCall()">
                  Call us: +971 52 872 2900
                </div>

                <div class="sign-form-text">
                  By signing up, you agree to our
                  <a href="<?php echo base_url('terms-and-conditions') ?>"
                    >T&amp;C</a
                    >
                    and
                    <a href="<?php echo base_url('privacy-policy') ?>"
                      >Privacy Policy</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
